import classNames from 'classnames';
import React, { createContext, ReactNode, useContext } from 'react';
import NavIdContext from './NavIdContext';

export const HeaderNavContext = createContext<'left' | 'right'>('left');

export interface NavItemsProps {
  children: ReactNode;
  id?: string;
  parentIds?: string[];
  hidden?: boolean;
}

/**
 * The NavItems provides a list wrapper for navigation items (links, buttons, dropdown menus).
 */

const NavItems = ({ children, id = '', hidden, parentIds = [] }: NavItemsProps): JSX.Element => {
  const alignment = useContext(HeaderNavContext);
  return (
    <NavIdContext.Provider value={[id, ...parentIds]}>
      <ul
        id={id}
        className={classNames('ver-nav__items', {
          'ver-nav--right': alignment === 'right',
        })}
        hidden={hidden}
      >
        {React.Children.map(children, (navItem) => {
          if (navItem === null || navItem === undefined || navItem === false) {
            return null;
          }

          return <li className="ver-nav__item">{navItem}</li>;
        })}
      </ul>
    </NavIdContext.Provider>
  );
};

export default NavItems;
